import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Helmet} from 'react-helmet'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const AffirmMessage = ({price}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {affirm} = commerceAPI
    const {configAffirm} = affirm || {}

    var enableCartCallout = false
    var publicApiKey = null
    var scriptUrl = null
    var affirmMinTotal = 50.0

    try {
        const jsonConfig = JSON.parse(configAffirm)

        enableCartCallout = jsonConfig.enableCartCallout
        publicApiKey = jsonConfig.apiKey
        scriptUrl = jsonConfig.scriptURL
        affirmMinTotal = jsonConfig.minTotal
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (window.affirm && window.affirm.ui && window.affirm.ui.ready) {
            window.affirm.ui.ready(() => {
                window.affirm.ui.refresh()
            })
        }
    }, [price])

    return (
        affirmMinTotal &&
        affirmMinTotal < price &&
        enableCartCallout && (
            <Box
                display={affirmMinTotal < price ? 'block' : 'none'}
                id={`affirm-message-cart`}
                sx={{
                    '.affirm-modal-trigger': {
                        textDecoration: 'underline',
                        fontSize: '10px'
                    }
                }}
            >
                <Helmet>
                    <script type="text/javascript">{`
                    var _affirm_config = { 
                        public_api_key: "${publicApiKey}",
                        script: "${scriptUrl}",
                        locale: "en_US"
                    };
                    (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
                `}</script>
                </Helmet>

                <Text
                    className="affirm-as-low-as"
                    data-min-total={affirmMinTotal}
                    data-page-type="cart"
                    data-amount={(price * 100)?.toFixed()}
                    data-affirm-color="black"
                ></Text>
            </Box>
        )
    )
}

AffirmMessage.propTypes = {
    price: PropTypes.any
}

export default AffirmMessage
